import { useContext } from "react";
import { UserContext } from "../../context/provider";
import { exportToCSV, FileInput } from "../mostlyUsed/mainComponents";

const CustomerSupport = () => {
  const { fileDatas, setFileDatas, verifiedCodes } = useContext(UserContext);

  const userIdIndex = 0
  const mobileIndex = 15
  const mobileBackupIndex = 14

  const submit = () => {
    let data = [...fileDatas.sell]
    console.log("fileDatas1: ", fileDatas);
    for (let i in fileDatas.sell) {
      if (i !== "0") {
        const userId = fileDatas.sell[i][userIdIndex]
        for (let g in fileDatas.customer) {
          if (userId === fileDatas.customer[g][userIdIndex]) {
            if (fileDatas.customer[g][mobileIndex]) {
              data[i].splice(3, 0, fileDatas.customer[g][mobileIndex]);
            } else {
              data[i].splice(3, 0, fileDatas.customer[g][mobileBackupIndex]);
            }
            break
          }
        }
      } else {
        data[i].splice(3, 0, fileDatas.customer["0"][mobileIndex]);
      }
    }
    console.log("fileDatas2: ", fileDatas);
    console.log("data: ", data);
    
    

    exportToCSV(data, null, "customers data")
  }

  return (
    <div className="mainComponent">
      <FileInput
        title="فایل گزارش فروش"
        fileName="sell"
        contextData={setFileDatas}
      />
      <FileInput
        title="فایل همه مشتریان"
        fileName="customer"
        contextData={setFileDatas}
      />
      <div>
        <button onClick={submit}>تایید</button>
      </div>
    </div>
  );
};

export default CustomerSupport;
